// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'store/user/user.selector';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
    const user = useSelector(selectCurrentUser);

    const navGroups = menuItem.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            case 'protected':
                return user ? <NavGroup key={item.id} item={item} /> : null;
            case 'admin':
                return user?.UserType === 'ADMIN' ? <NavGroup key={item.id} item={item} /> : null;
            case 'sadmin':
                return user?.UserType === 'SADMIN' ? <NavGroup key={item.id} item={item} /> : null;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Fix - Navigation Group
                    </Typography>
                );
        }
    });

    return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
